/**
 * Initial layer visibility configuration
 */
export const ms2Regions = [
  { id: "region-01", name: "Canadian-Upper Red" },
  { id: "region-02", name: "Lower Red-Sulphur-Cypress" },
  { id: "region-03", name: "Trinity" },
  { id: "region-04", name: "Sabine" },
  { id: "region-05", name: "Neches" },
  { id: "region-06", name: "San Jacinto" },
  { id: "region-07", name: "Upper Brazos" },
  { id: "region-08", name: "Lower Brazos" },
  { id: "region-09", name: "Upper Colorado" },
  { id: "region-10", name: "Lower Colorado-Lavaca" },
  { id: "region-11", name: "Guadalupe" },
  { id: "region-12", name: "San Antonio" },
  { id: "region-13", name: "Nueces" },
  { id: "region-14", name: "Upper Rio Grande" },
  { id: "region-15", name: "Lower Rio Grande" },
];

export const layerGroups = {
  sources: {
    id: "sources",
    title: "Sources",
    sections: ["rbfs", "ms2"],
  },
  rbfs: {
    id: "rbfs",
    title: "RBFS",
    layers: [
      {
        id: "east",
        title: "East",
        endpoint: "/regions/east/models",
        eachItem: [
          {
            lookupKey: "tdis_identifier",
            endpoint: "/keyword/search",
          },
        ],
      },
      {
        id: "west",
        title: "West",
        endpoint: "/regions/west/models",
        eachItem: [
          {
            lookupKey: "tdis_identifier",
            endpoint: "/keyword/search",
          },
        ],
      },
      {
        id: "central",
        title: "Central",
        endpoint: "/regions/central/models",
        eachItem: [
          {
            lookupKey: "tdis_identifier",
            endpoint: "/keyword/search",
          },
        ],
      },
      {
        id: "lrgv",
        title: "LRGV",
        endpoint: "/regions/lrgv/models",
        eachItem: [
          {
            lookupKey: "tdis_identifier",
            endpoint: "/keyword/search",
          },
        ],
      },
    ],
  },
  ms2: {
    id: "ms2",
    title: "MS2",
    layers: ms2Regions.map((region, _i) => {
      return {
        id: region.id, // Keep the ID simple for the UI
        title: region.name,
        stateKey: region.id, // Add the state key for mapping to state
        endpoint: `/regions/${region.id}/models`,
        eachItem: [
          {
            lookupKey: "tdis_identifier",
            endpoint: "/keyword/search",
          },
        ],
      };
    }),
  },
  counties: {
    id: "counties",
    title: "Counties",
    layers: [
      {
        id: "counties",
        title: "Counties",
        stateKey: "counties",
        endpoint: "/counties/with-counts",
        eachItem: [
          {
            lookupKey: "county_name",
            endpoint: "/keyword/search",
          },
        ],
      },
    ],
  },
};

export const initialLayerVisibility = {
  rbfs: {
    east: false,
    west: false,
    central: false,
    lrgv: false,
  },
  ms2: {
    "region-01": false,
    "region-02": false,
    "region-03": false,
    "region-04": false,
    "region-05": false,
    "region-06": false,
    "region-07": false,
    "region-08": false,
    "region-09": false,
    "region-10": false,
    "region-11": false,
    "region-12": false,
    "region-13": false,
    "region-14": false,
    "region-15": false,
  },
  counties: false,
};

/**
 * Layer configuration for different region types
 */
export const layerConfig = {
  rbfs: [
    { id: "east", name: "East" },
    { id: "west", name: "West" },
    { id: "central", name: "Central" },
    { id: "lrgv", name: "LRGV" },
  ],
  ms2: Array.from({ length: 15 }, (_, i) => {
    const num = String(i + 1).padStart(2, "0");
    return { id: `region-${num}`, name: `Region ${num}` };
  }),
};
